import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    //这个是控制选中背景的
    selesNav: 0,
}

const getters = {
    getNav(state) {
        return state.selesNav
    }
}

const mutations = {
    changeNavMuta(state, num) {
        state.selesNav = num;
    }
}

const actions = {
    changeNav(context, num) {
        context.commit('changeNavMuta', num)
    }
}
const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js